.viewer,
.viewerError {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--ant-color-bg-container);
  border: 1px solid var(--ant-color-border);
  border-radius: var(--ant-border-radius);
}

.viewerError {
  border-color: var(--ant-color-error-border);
}

.header {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 8px 12px;
  background: var(--ant-color-fill-alter);
  border-bottom: 1px solid var(--ant-color-border);
}

.viewerError .header {
  background: var(--ant-color-error-bg);
}

.title {
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 500;
  color: var(--ant-color-text);
}

.content {
  flex: 1;
  min-height: 120px;
  overflow: hidden;
}

.empty {
  padding: 24px;
}

.pre,
.tree {
  max-height: 400px;
  margin: 0;
  overflow: auto;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.5;
  color: var(--ant-color-text);
}

.pre {
  padding: 16px;
  white-space: pre;
  background: var(--ant-color-fill-quaternary);
}

.tree {
  padding: 12px;
}

.footer {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px 12px;
  font-size: 12px;
  color: var(--ant-color-text-secondary);
  background: var(--ant-color-fill-alter);
  border-top: 1px solid var(--ant-color-border);
}

.treeItem,
.treeItemExpandable {
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 1px 0;
}

.treeItemExpandable {
  width: 100%;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
  background: transparent;
  border: none;
}

.treeItemExpandable:hover {
  background: var(--ant-color-fill-tertiary);
}

.toggle,
.toggleOpen {
  font-size: 10px;
  color: var(--ant-color-text-tertiary);
  transition: transform 0.2s;
}

.toggleOpen {
  transform: rotate(90deg);
}

.children {
  padding-left: 20px;
  border-left: 1px dashed var(--ant-color-border-secondary);
}

.key {
  color: var(--ant-color-primary);
}

.type,
.length {
  font-size: 12px;
  color: var(--ant-color-text-tertiary);
}

.value_string {
  color: var(--ant-color-success);
}

.value_number {
  color: var(--ant-color-info);
}

.value_boolean {
  color: var(--ant-color-warning);
}

.value_null,
.value_undefined,
.value_other {
  color: var(--ant-color-text-tertiary);
}
